// extracted by mini-css-extract-plugin
export default {"legend":"vka-z","legendSpacing":"wka-z"};